import { fetchApi } from '@/config/axiosSetting';
import {
  GetBodyCustomerVehicleImagesQueryParamsType,
  GetBodyCustomerVehicleImagesQueryResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerVehicleImages/getBodyCustomerVehicleImagesQuery.type';

export const getBodyCustomerVehicleImagesQueryFunction = (
  params: GetBodyCustomerVehicleImagesQueryParamsType,
): Promise<GetBodyCustomerVehicleImagesQueryResponseType> => {
  return fetchApi.get(
    `/body/reports/${params.id}/images/customer/vehicle/`,
    {},
  );
};
